/** Il backend taglia la lista a 500 ordini (i piu' recenti): i chip e «Seleziona
 *  tutti» lavorano solo su quelli. Senza questo avviso gli ordini vecchi ancora
 *  da evadere spariscono dalla lista senza che nessuno lo sappia. */
export function ListaTroncataAvviso({ caricati, totale }: { caricati: number; totale: number }) {
  if (totale <= caricati) return null;
  return (
    <div
      role="status"
      className="inline-flex items-center px-3 py-1.5 rounded-full border border-amber/30 bg-amber-soft text-[11.5px] text-ink"
    >
      Lista parziale: mostro {caricati} di {totale} ordini (i piu' recenti). Restringi le date per
      vedere gli altri.
    </div>
  );
}
